export const IMPERSONATE_FAILED_MESSAGE = 'Unable to impersonate this user. Please try again.'

const IMPERSONATION_NOT_CONFIGURED_MESSAGE = 'User impersonation is not configured.'
const IMPERSONATION_REQUEST_FAILED_MESSAGE = 'User impersonation failed.'

const IMPERSONATION_NOT_CONFIGURED_CODE = 'IMPERSONATION_IS_NOT_CONFIGURED'
const IMPERSONATION_FAILED_CODE = 'IMPERSONATION_FAILED'

type PortalError = {
  portal_error_code?: unknown
  response?: {
    data?: {
      portal_error_code?: unknown
    }
  }
}

function getPortalErrorCode(error: unknown): string | undefined {
  if (!error || typeof error !== 'object') return undefined

  const portalError = error as PortalError
  const responseCode = portalError.response?.data?.portal_error_code
  const directCode = portalError.portal_error_code

  if (typeof responseCode === 'string') return responseCode
  if (typeof directCode === 'string') return directCode
  return undefined
}

export function getImpersonationErrorMessage(error: unknown): string {
  const code = getPortalErrorCode(error)

  if (code === IMPERSONATION_NOT_CONFIGURED_CODE) {
    return IMPERSONATION_NOT_CONFIGURED_MESSAGE
  }

  if (code === IMPERSONATION_FAILED_CODE) {
    return IMPERSONATION_REQUEST_FAILED_MESSAGE
  }

  // HTTP and Stytch/SDK failures have no dedicated Users-table copy. Keep the message
  // frontend-owned instead of surfacing API detail or raw SDK text.
  return IMPERSONATE_FAILED_MESSAGE
}
